import React from 'react';
import faqs from '../../data/faqs';

const Faq = () => (
    <div id="questions" className="sw-faq">
        <div className="sw-container sw-faq__inner">
            <p className="sw-eyebrow">Common questions</p>
            <h2 className="sw-heading sw-faq__title">A little clarity before you call.</h2>
            {faqs.map((item) => (
                <details key={item.q} className="sw-faq__item">
                    <summary>{item.q}</summary>
                    <p>{item.a}</p>
                </details>
            ))}
        </div>
    </div>
);

export default Faq;
